import { render } from "./CompanyInfo.vue?vue&type=template&id=0870b1fc"
const script = {}

import "./CompanyInfo.vue?vue&type=style&index=0&id=0870b1fc&lang=css"

import exportComponent from "D:\\curProject\\newTrip\\client\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__